import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { MerchantAccountService, MerchantAccountListItem } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class CashnetAccountsResolver implements Resolve<MerchantAccountListItem[]> {
    constructor(private readonly merchantAccountService: MerchantAccountService) { }

    resolve() {
        return this.merchantAccountService.getCashnetAccounts();
    }
}